const VALIDATE_PASSWORD = /^(?=.*[A-Z])(?=.*\d).{8,}$/

export { VALIDATE_PASSWORD }
